/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Online_Price_EditInputs */

const vi_online_price_edit = /** @type {(inputs: Online_Price_EditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sửa giá Online của ${i?.sku}`)
};

/**

* @param {Online_Price_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_edit = /** @type {((inputs: Online_Price_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_EditInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_edit(inputs)
});